exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no_list_warning[data-v-328f8dae] {\r\n  height: calc(100vh - 213px);\r\n  align-items: center;\r\n  justify-content: center;\n}\r\n", ""]);

// exports
